
import React, {Component} from 'react'
import Select from 'react-select';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { translate, formatDate } from '../../helpers/intl_helpers'

import { callBackendAPI, handleFormValidation, reFormatErrors, reFormatSuccess,  customConfirmBox, handleFormInputs, generateSource, cancelToken } from '../../helpers/common';
import { STATUS_SUCCESS, DATERANGE_DATE_TIME_FORMAT, RADIO_YES, RADIO_NO} from '../../config/global_constants';


import checkIcon from '../../assets/images/check_icon.svg';
import infoIcon from '../../assets/images/info-icon.svg';

const renderMultiSelectTooltip = (props) => (
    <Tooltip id="multi-select-tooltip" {...props}>
        {translate('calendar.shift_select_tooltip', 'Click the first date, scroll to the last job then hold Shift, and click the last date. This will allow you to multi-select a range of dates.')}
    </Tooltip>
);


class AssignMultipleJobModal extends Component {
    source;
    constructor(props) {
        super(props);
        this.state = {
            jobId : "",
            userId : this.props.userId,
            type : this.props.type,
            foremanId : this.props.foremanId,
            memberAsseId : this.props.memberAsseId,
            jobOptions : this.props.jobOptions,
            assignMemberAssetForJob : this.props.assignMemberAssetForJob,
            fields  : {
                job : (this.props.jobOptions?.length === 1) ? {value: this.props.jobOptions[0].value, label: this.props.jobOptions[0].label} : null,
                job_type :   {value: String(RADIO_YES)},
            },
            errors  : {},
            setJobGroupId: this.props.setJobGroupId,
            jobList: [],
            selectedJobIds: (this.props.jobOptions?.length === 1) ? [(this.props.jobOptions[0]?.value)] : [],
            selectAll: false,
            isAssignModal: this.props.isAssignModal,
            submitted			: false,
        };
        this.handleFormInputs       =   this.handleFormInputs.bind(this);
    }

    componentDidMount(){
        this.getJobList();
    }

    componentWillUnmount(){
        cancelToken(this.source); // cancel the request
    }

    /**
	* For get job listing
	*/
    getJobList = () =>{
        /** Generate source for cancel token */
        this.source = generateSource();
        const { setJobGroupId } = this.state;

		/** Set API request params */
        callBackendAPI([{model: 'jobs', method: 'getJobList', job_group_id: setJobGroupId}],this.source).then(response => {
           if(response.success && response.data[0].status === STATUS_SUCCESS && response.data[0].result) {
                this.setState({jobList: response.data[0].result});
            }
       }).catch(err => console.log(err));
   }// end getJobList()

   /**
	* For manage form submit event
	*
	* @param e as current form object
	*
	* @return null
	*/
	handleFormSubmit(e){
		e.preventDefault();
        let { selectedJobIds, type, memberAsseId, userId } = this.state;

		this.setState({
            submitted: true,
            fields : {
                ...this.state.fields,
                ...{
                    job_id: {value: selectedJobIds.length ? selectedJobIds : null},
                }
            }
        },()=>{
            /** Api Requested Data **/
            let params = [{
                model		: 	'jobs',
                method		: 	'assignMultiDayJob',
                user_id     :   userId || "",
                job_ids     :   selectedJobIds,
            }];
            if(type === "crew") params[0].employee_id = memberAsseId;
            if(type === "asset") params[0].asset_id = memberAsseId;

            let validations = {job: {label: translate('calendar.job'),rules: ['select']}};
            if (this.state.fields?.job && this.state.fields?.job?.value && selectedJobIds.length === 0) validations.job_id = {label: translate('calendar.jobs'),rules: ['select']};

            /** Handle validation and api response **/
            handleFormValidation(validations,this.state.fields, params,true , true, true ).then(response =>{

                if(response.success) {
                    this.props.handleCloseTaskModal();
                    this.props.updateEventCalendar(null,"calendar");
                    /** Remove disable attribute from submit button */
                    this.setState({ errors: {} , fields: {} , submitted: false});
                }else{
                    this.setState({ submitted: false});
                    let tmpErrors =  reFormatErrors(response?.data?.message);
                    let isForceAssign = (tmpErrors &&  tmpErrors != null && tmpErrors.force_resource_id ? tmpErrors.force_resource_id : "");
                    window.hideLoader();
                    if(isForceAssign){
                        let confirmation = customConfirmBox(isForceAssign,"",false,true,false,true);
                        confirmation.then((confirmed) => {
                            if (confirmed) {
                                /** Generate source for cancel token */
                                this.source = generateSource();

                                this.setState({ submitted: true});
                                let isProceedWithoutConflicts = false;
                                if(confirmed === "proceedWithoutConflicts") isProceedWithoutConflicts = true;

                                callBackendAPI([{
                                    model       : 'jobs',
                                    method      : 'assignMultiDayJob',
                                    user_id     : userId,
                                    job_ids     : selectedJobIds,
                                    employee_id : (type === "crew") ? memberAsseId : "",
                                    asset_id    : (type === "asset") ? memberAsseId : "",
                                    force_assign: isProceedWithoutConflicts ? false : true,
                                    is_proceed_without_conflicts: isProceedWithoutConflicts
                                }],this.source).then(response => {
                                    if (response.success && response?.data?.[0]?.status === STATUS_SUCCESS) {
                                        this.setState({ submitted: false});
                                        this.props.handleCloseTaskModal();
                                        reFormatSuccess(response?.data?.[0]?.message);
                                        this.props.updateEventCalendar(null,"calendar");
                                    }
                                }).catch(err => console.log(err));
                            }else{
                                window.hideLoader();
                            }
                        });
                    }else{
                        this.setState({submitted: false, errors : response.errors});
                    }
                }

            }).catch(err => console.log(err));
        });
	}

    /**
    * Firefox does not forward a shift-held click on a <label> to its associated
    * (display:none) checkbox - no "change" event fires at all in that case, even
    * though the same click works fine in Chrome. So selection can't be driven by
    * the checkbox's native toggle/change event; it has to be handled entirely here,
    * on the label's own click, with the native forwarding suppressed via
    * preventDefault() so behavior is identical and self-contained across browsers.
    */
    handleCardClick = (jobId, index) => (event) => {
        event.preventDefault();

        const { selectedJobIds, fields, jobList } = this.state;
        const isSingle = fields.job_type?.value === String(RADIO_YES);

        if (isSingle) {
            this.setState({ selectedJobIds: [jobId] });
            this.lastCheckedJobIndex = index;
            return;
        }

        // What a normal (non-shift) click would toggle this card to.
        const willBeChecked = !selectedJobIds.includes(jobId);

        // The anchor for a shift+click range may never have gone through an explicit
        // click (e.g. it came pre-selected by default) - fall back to the last selected
        // job's position in that case, so the range still resolves correctly.
        let anchorIndex = this.lastCheckedJobIndex;
        if (anchorIndex == null && selectedJobIds.length) {
            const anchorId = selectedJobIds[selectedJobIds.length - 1];
            const foundIndex = jobList.findIndex(job => job._id === anchorId);
            if (foundIndex !== -1) anchorIndex = foundIndex;
        }

        // Shift+click selects/deselects every job between the anchor and this one.
        // Plain click and Ctrl/Cmd+click both fall through to the same single-item
        // toggle below - neither ever clears the rest of the selection.
        if (event.shiftKey && anchorIndex != null && typeof index === "number") {
            const [start, end] = [anchorIndex, index].sort((a, b) => a - b);
            const rangeIds = jobList.slice(start, end + 1).map(job => job._id);

            if (willBeChecked) {
                this.setState({ selectedJobIds: Array.from(new Set([...selectedJobIds, ...rangeIds])) });
            } else {
                this.setState({ selectedJobIds: selectedJobIds.filter(id => !rangeIds.includes(id)), selectAll: false });
            }
        } else if (willBeChecked) {
            this.setState({ selectedJobIds: [...selectedJobIds, jobId] });
        } else {
            this.setState({ selectedJobIds: selectedJobIds.filter(id => id !== jobId), selectAll: false });
        }

        this.lastCheckedJobIndex = index;
    };

    handleChange = (fieldName) => (fieldVal) => {
        this.setState({
            foremanId: fieldVal.foreman_id,
            fields: {
                ...this.state.fields,
                [fieldName]: fieldVal
            }
        });
    };

     /**
    * For update state fields values
    *
    * @param e  	as current field object
    * @param field  as current field name
    *
    * @return null
    */
    handleFormInputs(e, field){
        let response	=	handleFormInputs(e, field, this.state.fields);
        this.setState({ response },()=>{
            if(field === "job_type"){
				this.setState({ selectedJobIds: [], selectAll: false });
			}
        })
    }// end handleFormInputs()

    handleSelectAllChange = (event) => {
        const { jobList } = this.state;
        if (event.target.checked) {
            this.setState({
                selectAll: true,
                selectedJobIds: jobList.map(job => job._id)
            });
        } else {
            this.setState({
                selectAll: false,
                selectedJobIds: []
            });
        }
    };

    render() {
        const {submitted, fields, errors, jobList, selectedJobIds, jobOptions, selectAll} = this.state;

        return <div className="modal fade crew-modal job-detail-modal" id="assignMultipleJobModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="asSubContractorJobLabel" aria-hidden="true">
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <button type="button" className="btn-close" onClick={()=>{this.props.handleCloseTaskModal()}}>X Close</button>
                    <div className="modal-body">
                          <h3>
                          {translate('calendar.assign_jobs')}
                        </h3>
                        <form onSubmit={(event) => this.handleFormSubmit(event)} noValidate>
                            <div className="form-group form-floating ">
                                <Select
                                    className="custom-react-select"
                                    value={fields?.job || null}
                                    options={jobOptions}
                                    onChange={(value) => {
                                        this.handleChange('job')(value);
                                        this.setState(
                                            { setJobGroupId: value?.job_group_id },
                                            this.getJobList
                                        );
                                    }}
                                    closeMenuOnSelect={true}
                                    placeholder={
                                        <div>
                                            <label htmlFor="job">
                                                {translate('calendar.select_job')}
                                            </label>
                                        </div>
                                    }
                                />
                                <span className="error text-danger">{this.state.errors["job"]}</span>
                            </div>
                            <div className="form-group form-floating ">
                                <div className='form-group'>
                                    {/* <label htmlFor="job_type" className="form-label">{translate('calendar.select_job_type')} </label> */}
                                    <div className='form-group checkbox-row employee-checkbox-row mt-0'>
                                        <div className="form-check form-check-inline custom-checkbox">
                                            <input className="form-check-input" type="radio" name="job_type" id="job_typeyes" value={RADIO_YES} onChange={(e) => this.handleFormInputs(e, "job_type")} defaultChecked={fields.job_type && fields.job_type.value === String(RADIO_YES) ? true :false} />
                                            <label className="form-check-label" htmlFor="job_typeyes">
                                                {translate('calendar.single')}
                                            </label>
                                        </div>
                                        <div className="form-check form-check-inline custom-checkbox">
                                            <input className="form-check-input" type="radio" name="job_type" id="job_typeno" value={RADIO_NO} onChange={(e) => this.handleFormInputs(e, "job_type")} defaultChecked={fields.job_type && fields.job_type.value === String(RADIO_NO) ? true :false} />
                                            <label className="form-check-label" htmlFor="job_typeno">
                                            {translate('calendar.multiple')}
                                            </label>
                                        </div>
                                    </div>
                                    <span className="error text-danger">{this.state.errors["job_type"]}</span>
                                </div>
                            </div>
                            {(fields.job_type && fields.job_type.value === String(RADIO_NO)) &&
                                <div className="form-check all-selector-box">
                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id="all_selector"
                                        checked={selectAll}
                                        onChange={this.handleSelectAllChange}
                                    />
                                    <label className="form-check-label" htmlFor="all_selector">
                                    {translate('calendar.select_all')}
                                    </label>
                                    <span className="shift-select-hint text-muted d-block">
                                        <strong>{translate('calendar.multi_select', 'Multi-Select')}:</strong> {translate('calendar.shift_select_hint', 'Holding the Shift key lets you select multiple dates.')}
                                        <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={renderMultiSelectTooltip}>
                                            <img src={infoIcon} className='ms-1' alt="info-icon" />
                                        </OverlayTrigger>
                                    </span>
                                </div>
                            }

                            {fields?.job?.value &&
                                <ul className='job-detail-listing'>
                                    {jobList.map((job, index) => (
                                        <li  key={job._id}>
                                            <div className="form-check" key={job._id}>
                                                <input
                                                    className="form-check-input"
                                                    type={(fields.job_type && fields.job_type.value === String(RADIO_YES)) ? "radio" : "checkbox"}
                                                    id={`job_${job._id}`}
                                                    name="jobs"
                                                    checked={selectedJobIds.includes(job._id)}
                                                    readOnly
                                                />
                                                <label className="form-check-label" htmlFor={`job_${job._id}`} onClick={this.handleCardClick(job._id, index)}>
                                                    <div className="jobs-date">{job.date ? formatDate(job.date, DATERANGE_DATE_TIME_FORMAT) : "N/A"}</div>
                                                    <span>{job.job_number ? job.job_number : "N/A"}</span>
                                                    <p>{job.manager_name ? job.manager_name : "N/A"}</p>
                                                    <div className="jobs-check">
                                                        <img src={checkIcon} alt="Copy icon" />
                                                    </div>
                                                </label>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            }
                            <span className="error text-danger mb-3 d-block">{errors["job_id"]}</span>
                            <div className='col-xl-12 d-flex'>
                                <button type={submitted ? "button" :"submit"} className="btn btn-fill">
                                    {translate('system.submit')}{submitted && <i className="spinner-border spinner-border-sm  ms-3"/>}
                                </button>
                                <button type="button" className="btn btn-outline ms-3" onClick={()=>{this.props.handleCloseTaskModal()}} data-dismiss="modal">
                                    {translate('system.close')}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    }
}

export default AssignMultipleJobModal
